import { getHtmlStyle } from '../transfer';

const msg = {
  render(node, children) {
    const { props } = node;
    const { attrs, style, action } = props;

    const computeStyle = Object.assign({}, style);

    /**
         * orientation默认值horizontal
         */
    const { orientation = 'horizontal' } = attrs;

    computeStyle.display = 'flex';
    if (orientation === 'horizontal') {
      computeStyle.flexDirection = 'row';
    } else if (orientation === 'vertical') {
      computeStyle.flexDirection = 'column';
    }

    if (style.display === 'none') {
      computeStyle.display = 'none';
    }

    if (orientation === 'vertical') {
      if (style.justifyContent) {
        if (style.justifyContent === 'center') {
          computeStyle.alignItems = 'center';
          computeStyle.textAlign = 'center';
        } else if (style.justifyContent === 'flex-start') {
          computeStyle.alignItems = 'flex-start';
          computeStyle.textAlign = 'left';
        } else if (style.justifyContent === 'flex-end') {
          computeStyle.alignItems = 'flex-end';
          computeStyle.textAlign = 'right';
        }

        if (!style.alignItems) {
          delete computeStyle.justifyContent;
        }
      }

      if (style.alignItems) {
        if (style.alignItems === 'center') {
          computeStyle.justifyContent = 'center';
        } else if (style.alignItems === 'flex-start') {
          computeStyle.justifyContent = 'flex-start';
        } else if (style.alignItems === 'flex-end') {
          computeStyle.justifyContent = 'flex-end';
        }

        if (!style.justifyContent) {
          delete computeStyle.alignItems;
        }
      }
    }

    if (action.actionCmd === 'browser' || action.actionCmd === 'web') {
      const stopBehavior = 'javascript:;';
      const link = /^http(s)?/.test(action.actionData) ? action.actionData : stopBehavior;

      return `<div class="msg-xml-container"><a ${link === stopBehavior ? '' : 'target="_blank"'} href="${link}" style="${getHtmlStyle(computeStyle)}">${children}</a></div>`;
    }
    return `<div class="msg-xml-container"><div style="${getHtmlStyle(computeStyle)}">${children}</div></div>`;
  },
};

export default msg;
